<template>
  <div>
    <router-view v-if="isLogin" />
  </div>
</template>
<script>
import { ref } from "vue";
import { loginByFeishu } from "./http/api";
const getQueryString = (name) => {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
  var u = decodeURIComponent(window.location.search).substr(1).match(reg);
  if (u != null) {
    return unescape(u[2]);
  }
  return null;
};
export default {
  setup() {
    const code = getQueryString("code") || "";
    // 飞书回调带 code 时先别渲染页面，避免子页面抢先请求接口触发 -101020 把登录态清掉
    const isLogin = ref(!code);
    if (!code) {
      const existingToken = localStorage.getItem("sessionToken");
      if (!existingToken && window.location.hostname !== "localhost") {
        let url = "https://giga-admin.xiaote.net";
        url = encodeURIComponent(url);
        window.location.href = `https://open.feishu.cn/open-apis/authen/v1/index?app_id=cli_a4d22b0513b8100e&redirect_uri=${url}`;
      }
    } else {
      loginByFeishu({ variables: { code } }).then((res) => {
        let { sessionToken, lcSessionToken } = res.data.loginByFeishu;
        localStorage.setItem("sessionToken", sessionToken);
        localStorage.setItem("lcSessionToken", lcSessionToken);
        isLogin.value = true;
        window.history.replaceState({}, document.title, window.location.pathname);
      }).catch(() => {
        localStorage.removeItem("sessionToken");
        localStorage.removeItem("lcSessionToken");
        if (window.location.hostname !== "localhost") {
          let url = "https://giga-admin.xiaote.net";
          url = encodeURIComponent(url);
          window.location.href = `https://open.feishu.cn/open-apis/authen/v1/index?app_id=cli_a4d22b0513b8100e&redirect_uri=${url}`;
        }
      });
    }
    return {
      isLogin,
    };
  },
};
</script>
<style lang="scss">
@import url(./global.scss);
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
}
</style>
